const REPORT_TYPES = [
    'kpi',
    'trends',
    'losses',
    'data_entry_performance',
    'maintenance_extended',
    'quality',
    'changeover',
    'benchmark'
];

export { REPORT_TYPES };
